<template src="./BestSeller.html"></template>
<style lang="scss" scoped src="./BestSeller.scss"></style>

<script>
import {
  SfHeading,
  SfSection,
  SfLink,
  SfImage,
  SfIcon,
  SfNotification
} from '@storefront-ui/vue';
import {OrkLoader} from "@/components/Ork";

import Api from "@/api/Api";
import {Navigation, Pagination, Autoplay} from 'swiper'

import {SwiperCore, Swiper, SwiperSlide} from 'swiper-vue2'

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Autoplay])

import OrkProductCart from "@/components/Ork/OrkProductCart";
import {LightProduct} from "@/models/product";
import icons from "@/utils/icons";

export default {
  name: "BestSeller",
  components: {
    SfHeading,
    SfSection,
    SfIcon,
    SfLink,
    SfImage,
    SfNotification,
    OrkLoader,
    Swiper,
    SwiperSlide,
    OrkProductCart
  },
  data() {
    return {
      title: null,
      description: null,
      products: [],
      loading: false,
      error: null,
      icons: icons
    }

  },
  created() {
    this.getBestSeller();
  },
  methods: {
    getBestSeller() {
      this.loading = true;
      this.products = [];
      Api.marketing.getBestSellers()
          .then(bestseller => {
            this.title = bestseller.title;
            this.description = bestseller.description;
            Api.product.getBySkuList(bestseller.products).then((data) => {
              for (const lightProduct of data) {
                this.products.push(LightProduct.of(lightProduct));
              }
            }).catch((e) => {
              this.error = e;
            })
                .finally(() => {
                  this.loading = false
                });

          })
          .catch((e) => {
            this.error = e;
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
}

</script>